// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class InlineObject {
    static getAttributeTypeMap() {
        return InlineObject.attributeTypeMap;
    }
}
InlineObject.discriminator = undefined;
InlineObject.attributeTypeMap = [
    {
        "name": "type",
        "baseName": "type",
        "type": "number"
    },
    {
        "name": "attachment",
        "baseName": "attachment",
        "type": "RequestFile"
    }
];
//# sourceMappingURL=inlineObject.js.map